module.exports = __webpack_public_path__ + "img/sierraint3.15da046d.png";